import {VehicleUsage} from './VehicleUsage';
import {ParkingSecurity} from './ParkingSecurity';
import {VehicleDetails} from './VehicleDetails';
import {Address} from './Address';
import {TransUnionEnquiryList} from './quotes/TransUnionEnquiryList';
import {LicenseDetails} from './LicenseDetails';
import {Suburb} from "./Suburb";

export class QuotationRequest {
  // Your Details
  public name: string = null;
  public surname: string = null;
  public cellphone: string = null;
  public legalRefType: string = null;
  public idNumber?: string = null;
  public passportNumber?: string = null;
  public dateOfBirth?: string = null;
  public gender?: string = null;
  public email: string = null;
  public campaign: string = null;
  public suburb: Suburb = new Suburb();
  public parkingAddress: Address = new Address();
  public vehicleUsage: VehicleUsage = VehicleUsage.SELECT_USAGE;
  public parkingSecurity: ParkingSecurity = ParkingSecurity.SELECT_SECURITY;
  public vehicleDetails: VehicleDetails = new VehicleDetails();
  public licenseDetails: LicenseDetails = new LicenseDetails();
  public comment: string = null;
  public medium: string = null;
  public fbClickID: string = null;
  public fbBrowserID: string = null;
  public urlParams: string = null;
  // Your Consent
  public isConsentGiven: boolean = null;
  public transUnionEnquiryList: TransUnionEnquiryList;
// Your vehicle
  constructor() {
  }

}
